
<div>
  @switch (businessLine) {
    @case (CarBusinessLine.BUY) {
      <h1>Mes alertes achat ({{ (myProfile$ | async)!.alerts.length }})</h1>
    }
    @case (CarBusinessLine.RENT) {
      <h1>Mes alertes location ({{ (myProfile$ | async)!.alerts.length }})</h1>
    }
    @case (CarBusinessLine.KEEP) {
      <h1>Mes alertes entretien ({{ (myProfile$ | async)!.alerts.length }})</h1>
    }
  }
</div>

<app-alerts
  [alerts]="(myProfile$ | async)!.alerts">

</app-alerts>
